
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { RoleAccess } from '../../../models/role-access.model';
import { UserProfile } from '../../../models/user-profile.model';
import { UserData } from '../../../providers/user-data';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UtilService } from '../../../service/util.service';
import { SetupTourGuideService } from '../setup-tour-guide.service';
import { IonicSelectableComponent } from 'ionic-selectable';
import { MyService } from '../../../service/my.service';
@Component({
  selector: 'app-setup-tour-guide-form',
  templateUrl: './setup-tour-guide-form.page.html',
  styleUrls: ['./setup-tour-guide-form.page.scss'],
})
export class SetupTourGuideFormPage implements OnInit {
  
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent
  action:any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  formSetupTourGuide: FormGroup;
  setupTourGuideId:any;
  selectedCounter:any[]=[];
  mstCounterList:any=[];
  msgMaxPercent:any='';
  constructor(
    private activeRoute: ActivatedRoute,
    private userData: UserData,
    private toastCtrl : ToastController,
    private navCtrl : NavController,
    private alertController : AlertController,
    private storage: Storage,
    private router: Router,
    private fb: FormBuilder,
    private utilService:UtilService,
    private setupTourGuideService:SetupTourGuideService,
    private myService:MyService
  ) { }

  ngOnInit() {
    this.buildFormSetupTourGuide();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.update!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        this.getData();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  buildFormSetupTourGuide() {
    this.formSetupTourGuide = this.fb.group({
      counterList:[null],
      discountType: [null],
      discountValue: [null],
      activeFlag: ['Y']
    });
  }
  getData() {
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.action = AES.decrypt(snapshot.a, myKey).toString(utf8);
      this.setupTourGuideId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      this.selectedCounter =[];
      if(this.action!='adds'){
        let option={
          "token": this.token,
          "id":this.setupTourGuideId,
          "username":this.userProfile.username
        };
        this.setupTourGuideService.getSetupTourGuideById(this.setupTourGuideId,option)
        .subscribe((response: any) => {
          let rs = response.results.setup_tour_guide;
          let discount_type = rs!=null ? rs.discount_type : '';
          let discount_value = rs!=null ? parseInt(rs.discount_value) : '';
          let active_flag = rs!=null ? rs.active_flag : 'Y';
          let counter_list = rs!=null ?rs.counter_list:'';
          this.mstCounterList = response.results.counter;
          let counterIdSplit = counter_list !== '' ? String(counter_list).split(',') : [];
          let selectedCounterx = [];
          if(counterIdSplit.length>0){
            for(let i= 0; i < counterIdSplit.length; i++) {        
              let selectedCounter: any = this.mstCounterList.find(x => x.id ==  parseInt(counterIdSplit[i]));
              if(selectedCounter){
                this.selectedCounter.push(selectedCounter.id);  
                selectedCounterx.push(selectedCounter)      
              }
            }
          }
          this.formSetupTourGuide.patchValue({
            counterList:selectedCounterx,
            discountType: discount_type,
            discountValue: discount_value,
            activeFlag:active_flag
          });
        });
      }
    });
  }
  selectCounter(event){
    this.selectedCounter = [];
    for(let i= 0; i < event.value.length; i++) {
      this.selectedCounter.push(event.value[i]['id']);
    }
  }
  saveSetupTourGuide(){
    const setupTourGuideData = this.formSetupTourGuide.getRawValue();
    if(setupTourGuideData.discountType==0 || setupTourGuideData.discountType==null){
      alert("Discount Type tidak boleh kosong");
      return;
    }
    if(setupTourGuideData.discountValue==0 || setupTourGuideData.discountValue==null){
      alert("Discount Value tidak boleh kosong");
      return;
    }
    let nominalValueWithoutseparator = String(setupTourGuideData.discountValue).replace(/[^0-9]/g, '');
    if(setupTourGuideData.discountType=='percent' && Number(nominalValueWithoutseparator)>100){
      this.msgMaxPercent='Max 100%';
      alert("Max Discount 100%");
      return;
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "action":this.action,
        "id":this.setupTourGuideId,
        "discount_type":setupTourGuideData.discountType ?  setupTourGuideData.discountType : '',
        "discount_value":setupTourGuideData.discountValue ? String(setupTourGuideData.discountValue).replace(/[^0-9]/g, '') : '0',
        "counter_list":this.selectedCounter.toString(),
        "active_flag":setupTourGuideData.activeFlag ?  setupTourGuideData.activeFlag : 'N',
        "username":this.userProfile.username
      };
      this.setupTourGuideService.saveSetupTourGuide(options)
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        }
        else if(response.status.code === 409) {
          this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.buildFormSetupTourGuide();
            this.navCtrl.navigateForward(['/setup-tour-guide']);;
          }
        }
      ]
    });
    await alert.present();
  }
  
  toggleCounterItems() {
    this.counterComponent.toggleItems(
      this.counterComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmCounter() {
    this.counterComponent.confirm();
    this.counterComponent.close();
    let counterList = this.counterComponent.value;
    let idCounter ='';
    for(let i=0;i<counterList.length;i++){
      idCounter += this.selectedCounter[i].id+',';
    }
    idCounter = idCounter.replace(/(^,)|(,$)/g, "");
  }
  
  onChangePrice(columnname:any){ 
    let cur= this.formSetupTourGuide.getRawValue()[columnname];
    let curWithSeparator='0';
    if(cur!='0' && cur!='' && cur!=null){
      curWithSeparator = this.myService.separator(cur);
      curWithSeparator = String(curWithSeparator).replace(/[^0-9,.]/g, '');
    }
    const voucherForm = this.formSetupTourGuide.getRawValue();
    let nominalValueWithoutseparator = String(this.formSetupTourGuide.get(columnname).value).replace(/[^0-9]/g, '');
    if(voucherForm.discountType=='percent' && Number(nominalValueWithoutseparator)>100){
      this.msgMaxPercent='Max 100%';
    }
    else{
      this.msgMaxPercent ='';
    }
    this.formSetupTourGuide.patchValue({[columnname]:curWithSeparator});
  }
}
